import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { PRODUCT_IMAGE, goToCheckout } from '../lib/constants';
const trustBadges = [{
  emoji: '📄',
  label: '100% PDF'
}, {
  emoji: '⚡️',
  label: 'Entrega Inmediata'
}, {
  emoji: '📚',
  label: '14 Módulos + 7 Bonos'
}];
// Above-the-fold hero: headline, product image, subhead, badges and first CTA.
export function Hero() {
  return <section className="px-5 pt-8 pb-6" data-id="element-73">
      <div className="mx-auto max-w-md" data-id="element-74">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="text-center font-[Montserrat] text-[26px] font-extrabold leading-tight text-white sm:text-3xl" data-id="element-75">
          Aprueba el PER a la primera,{' '}
          <span className="text-[#e6c168]" data-id="element-76">
            sin depender de academias ni horarios
          </span>
        </motion.h1>

        <motion.button type="button" onClick={goToCheckout} initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} aria-label="Ver la oferta de compra" className="mx-auto mt-6 block w-4/5 overflow-hidden rounded-2xl border-2 border-[#c8a24a]/50 shadow-2xl shadow-black/40" data-id="element-77">
          <img src={PRODUCT_IMAGE} alt="Pack Licencia de Navegación Sencilla — Manual PER con 14 módulos y 7 bonos" className="h-auto w-full" data-id="element-78" />
        </motion.button>

        <p className="mt-6 text-center text-[15px] leading-relaxed text-blue-100" data-id="element-79">
          14 módulos, 65 preguntas comentadas y herramientas de práctica listas
          para descargar hoy. Empiezas a estudiar en los próximos 5 minutos.
        </p>

        <div className="mt-5 flex flex-wrap items-center justify-center gap-2" data-id="element-80">
          {trustBadges.map(b => <span key={b.label} className="flex items-center gap-1.5 rounded-full border border-[#c8a24a]/40 bg-[#0b2545]/70 px-3 py-1.5 text-xs font-bold text-white" data-id="element-81">
              <span aria-hidden="true" data-id="element-82">{b.emoji}</span>
              {b.label}
            </span>)}
        </div>

        <div className="mt-6" data-id="element-83">
          <CtaButton data-id="element-84" />
        </div>
      </div>
    </section>;
}